import { CognitiveIndex } from 'apps/web/enums/iPlanObjectives/categories.enum';
import { BehavioralVerb } from 'apps/web/types/labelled-collection.type';

import * as digital from './digital';
import * as standard from './standard';

export const createCognitiveCategoryLabels = () => [
  'Creating',
  'Evaluating',
  'Analyzing',
  'Applying',
  'Understanding',
  'Remembering',
];

export const getCognitiveVerbs = (
  isDigital: boolean,
): Record<number, BehavioralVerb[]> => {
  return isDigital
    ? {
        [CognitiveIndex.Remembering]: digital.DIGITAL_REMEMBERING_VERBS,
        [CognitiveIndex.Understanding]: digital.DIGITAL_UNDERSTANDING_VERBS,
        [CognitiveIndex.Applying]: digital.DIGITAL_APPLYING_VERBS,
        [CognitiveIndex.Analyzing]: digital.DIGITAL_ANALYZING_VERBS,
        [CognitiveIndex.Evaluating]: digital.DIGITAL_EVALUATING_VERBS,
        [CognitiveIndex.Creating]: digital.DIGITAL_CREATING_VERBS,
      }
    : {
        [CognitiveIndex.Remembering]: standard.STANDARD_REMEMBERING_VERBS,
        [CognitiveIndex.Understanding]: standard.STANDARD_UNDERSTANDING_VERBS,
        [CognitiveIndex.Applying]: standard.STANDARD_APPLYING_VERBS,
        [CognitiveIndex.Analyzing]: standard.STANDARD_ANALYZING_VERBS,
        [CognitiveIndex.Evaluating]: standard.STANDARD_EVALUATING_VERBS,
        [CognitiveIndex.Creating]: standard.STANDARD_CREATING_VERBS,
      };
};
